import { render, staticRenderFns } from "./ForApproval.vue?vue&type=template&id=08b5d146&scoped=true&"
import script from "./ForApproval.vue?vue&type=script&lang=js&"
export * from "./ForApproval.vue?vue&type=script&lang=js&"
import style0 from "./ForApproval.vue?vue&type=style&index=0&id=08b5d146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5d146",
  null
  
)

export default component.exports